var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import get from 'lodash/get';
import { AnimatePresence, motion } from 'framer-motion';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { CommonActions, Events, JourneysSelectors, ResultsActions, ResultsSelectors, TrackingActions, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { Loading, LoadingResultAnimation } from 'conversional-components';
import ResultPage from '../components/ResultPage';
import Fullscreen from '../components/Fullscreen';
import { CLOSED, OPEN } from './General.styles';
import { useListener } from '../utils/listener';
import { triggerSessionReplay } from '../utils/errorTracker';
var environment = process.env.REACT_APP_JOURNEY_ENV || 'development';
var DELAY = environment === 'development' ? 0 : 8000;
var SHORT_DELAY = environment === 'development' ? 0 : 3000;
var Result = function (_a) {
    //   utils.focusModal() => TODO: rewrite the function to trigger onc eon modal open to not scroll the background
    // TODO: Z-index management of active window!
    var onApplyStyles = _a.onApplyStyles;
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var loading = useAppSelector(ResultsSelectors.selectResultLoading);
    var useKitchenAnimation = useAppSelector(JourneysSelectors.selectKitchenAnimation);
    var result = useAppSelector(ResultsSelectors.selectResultsState);
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(null), resultId = _c[0], setResultId = _c[1];
    var _d = React.useState(''), loadingKitchenMessage = _d[0], setLoadingKitchenMessage = _d[1];
    var _e = React.useState(false), showResult = _e[0], setShowResult = _e[1];
    var displayAnimation = function () {
        setShowResult(false);
        var timer = setTimeout(function () {
            setShowResult(true);
        }, loadingKitchenMessage ? DELAY : SHORT_DELAY);
        return function () {
            setShowResult(false);
            clearTimeout(timer);
        };
    };
    useEffect(function () {
        if (open && resultId) {
            sendToHost.publish(MESSAGETYPES.JOURNEY_RESULT_READY);
            sendToHost.iframeOnScreen();
            dispatch(CommonActions.broadcastSharedStoreChange({
                resultIsOpen: true,
            }));
        }
    }, [open, resultId]);
    var show = function (_a) {
        var resultId = _a.resultId;
        setResultId(resultId);
        setOpen(true);
        dispatch(ResultsActions.loadResult(resultId));
        dispatch(ResultsActions.loadResultLikes(null));
        displayAnimation();
        sendToHost.styleIframe(OPEN, true);
        onApplyStyles();
        triggerSessionReplay(true);
        trackEvent(Events.JOURNEY_RESULT);
    };
    var hide = function () {
        setOpen(false);
        triggerSessionReplay(false);
        sendToHost.styleIframe(__assign(__assign({}, CLOSED), { transition: 'none' }), true);
        sendToHost.iframeOffScreen();
        dispatch(CommonActions.broadcastSharedStoreChange({
            resultIsOpen: false,
        }));
        if (!open) {
            return;
        }
        trackEvent(Events.JOURNEY_RESULT_HIDE);
    };
    var clear = function () {
        setResultId(null);
        setShowResult(false);
        dispatch(CommonActions.clearState());
        hide();
    };
    var showMessage = function (_a) {
        var message = _a.message;
        setLoadingKitchenMessage(message);
    };
    useListener(MESSAGETYPES.JOURNEY_SHOW_ENTRY, clear);
    useListener(MESSAGETYPES.JOURNEY_CLOSE, hide);
    useListener(MESSAGETYPES.JOURNEY_SHOW_RESULT, show);
    useListener(MESSAGETYPES.JOURNEY_RESTART, clear);
    useListener(MESSAGETYPES.SEND_LOADING_MESSAGE, showMessage);
    if (!open || !resultId) {
        return null;
    }
    var variants = {
        show: {
            transition: {
                ease: [0.465, 0.183, 0.153, 0.946],
                duration: 0.3,
            },
            opacity: 1,
        },
        exit: {
            transition: {
                ease: [0.465, 0.183, 0.153, 0.946],
                duration: 0.3,
            },
            opacity: 0,
        },
    };
    return (_jsx(Fullscreen, { modalProps: get(result, 'content.root.Window.modalProps'), onAnimationComplete: function () { }, onClose: hide, children: _jsx(AnimatePresence, { children: useKitchenAnimation && (!showResult || loading) ? (_jsx(motion.div, { animate: "show", exit: "exit", variants: variants, style: { height: '100%' }, children: _jsx(LoadingResultAnimation, { loadingMessage: loadingKitchenMessage }) }, "kitchen-animation")) : loading ? (_jsx(motion.div, { animate: "show", exit: "exit", variants: variants, style: { height: '100%' }, children: _jsx(Loading, {}) }, "default-animation")) : (_jsx(motion.div, { animate: "show", exit: "exit", variants: variants, style: { height: '100%' }, children: _jsx(ResultPage, { resultId: resultId }) }, "result")) }) }));
};
export default Result;
